import { useQuery } from "react-query";
import { ApiError } from "utils/api/models/api-error";
import ApiResult from "utils/api/models/api-result";
import { TicketServiceModel } from "models/ticketServices";
import { FetchServicesByLevel } from "services/Services";

export default function useServicesByLevel(
  id: number,
  page: number,
  perPage: number,
  enabled: boolean
) {
  const queryKey = ["services-by-level", id, page, perPage];
  return {
    ...useQuery<ApiResult<TicketServiceModel[]>, ApiError>(
      queryKey,
      () => FetchServicesByLevel(id, page, perPage),
      {
        enabled: enabled,
        staleTime: 10000,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        getNextPageParam: (lastPage) =>
          lastPage?.meta?.currentPage! + 1 ?? false,
      }
    ),
  };
}
